module.exports = __webpack_public_path__ + "static/img/35.2f98cea6.png";